import { useContext } from 'react'
import { SnackbarContext } from './snackbar-context'

const useSnackbar = () => {
  const context = useContext(SnackbarContext)

  const { addSnackbar, removeSnackbar, snackbarsList } = context

  return { addSnackbar, removeSnackbar, snackbarsList }
}

export { useSnackbar }
